module.exports = __webpack_public_path__ + "img/set-complet-creativo.f8fb978c.jpg";